export const SKELETON_PAGE_SIZE = 10;
export const RESULTS_PER_PAGE = 50;
